import { render, staticRenderFns } from "./ApplyFail.vue?vue&type=template&id=20971470&scoped=true&"
import script from "./ApplyFail.vue?vue&type=script&lang=js&"
export * from "./ApplyFail.vue?vue&type=script&lang=js&"
import style0 from "./ApplyFail.vue?vue&type=style&index=0&id=20971470&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20971470",
  null
  
)

export default component.exports